import moment from "moment";
import React, {useEffect, useState} from "react";
import { Container, Button, Icon, Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "semantic-ui-react";
//import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import DartsGamesCRUDForm from "./DartsGamesCRUD.form";
import DartsGamesFilter from "./components/dartsGamesFilter/DartsGamesFilter";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import {
    changePageSize,
    //deleteDartsGame,
    getDartsGames,
    getDartsGamesInit, setActivePage, setEditMode,
    showGamesForm
} from "./DartsGamesCRUD.slice";
import { DartsGameData } from "./DartsGamesCRUD.types";
import { buildQueryString } from "../../../helpers/buildQueryString";
import CheckboxCms from "../../../components/CheckboxCms/CheckboxCms";
import './DartsGamesCRUD.scss'
import AppPagination from "../../../components/Pagination/AppPagination";

const DartsGamesCRUD = () => {
    const [isShowFilter, setIsShowFilter] = useState(false);
    const dispatch = useAppDispatch();
    const cms = useAppSelector(state => state.Auth.cms);
    const {dartsGames, isVisibleForm, pagination, filterValues} = useAppSelector(state => state.DartsGamesCRUD);

    useEffect(() => {
        filterGames()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues]);

    useEffect(() => {
        dispatch(getDartsGamesInit());
    }, [dispatch]);

    const filterGames = () => {
        dispatch(setActivePage(1))
        const params = { ...filterValues, pageNum: 1, pageSize: pagination.pageSize}
        dispatch(getDartsGames(buildQueryString(params)));
    }

    const onOpenFilter = () => {
        setIsShowFilter(true);
    };

    const generateButtons = (game: DartsGameData) => {
        if (game.status === "NotActive" && cms['delete']) {
            return (
                <div className={"table-controls-btn"}>
                    {/*<DeleteModal id={game.id} titleModal={"Delete your Game"}*/}
                    {/*    confirmText={"Are you sure you want to delete your handler?"}*/}
                    {/*    deleteAction={() => dispatch(deleteDartsGame({ type: game.type, id: game.id }))}*/}
                    {/*/>*/}
                    <Icon name='pencil alternate' link size="small" color="grey" onClick={() => dispatch(setEditMode(game.id))} />
                </div>
            );
        }
    };

    const showForm = () => {
        dispatch(showGamesForm())
    }
    const onChangePager = (activePage: string | number | undefined) => {
        dispatch(setActivePage(activePage))
        const params = { ...filterValues, pageNum: activePage, pageSize: pagination.pageSize }
        dispatch(getDartsGames(buildQueryString(params)));
    }

    const onChangePageSize = (value: any) => {
        const params = { ...filterValues, pageNum: pagination.activePage, pageSize: value}
        dispatch(changePageSize(value))
        dispatch(getDartsGames(buildQueryString(params)));
    }

    return (
        <div className="cms-container-general">
            <Container textAlign='right'>
                <Button color="yellow" onClick={onOpenFilter}>Filter</Button>
                <Button color="green" onClick={showForm} id="add_game">Add</Button>
            </Container>
            <div className="cms-table-general">
                <Table celled striped textAlign="center">
                    <TableHeader>
                        <TableRow>
                            {cms['id'] &&
                                <TableHeaderCell>Id</TableHeaderCell>
                            }
                            <TableHeaderCell>Tournament</TableHeaderCell>
                            <TableHeaderCell>Location</TableHeaderCell>
                            <TableHeaderCell>Players</TableHeaderCell>
                            <TableHeaderCell>Date start</TableHeaderCell>
                            <TableHeaderCell>Status</TableHeaderCell>
                            <TableHeaderCell>Double start</TableHeaderCell>
                            <TableHeaderCell>Leg To Win</TableHeaderCell>
                            <TableHeaderCell/>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {dartsGames?.map((game) => {
                            return (
                                <TableRow key={game.id.toString()}>
                                    {cms['id'] &&
                                        <TableCell>{game.id}</TableCell>
                                    }
                                    <TableCell>{game.tournament}</TableCell>
                                    <TableCell>{game.location}</TableCell>
                                    <TableCell>{game.players}</TableCell>
                                    <TableCell>{moment(game.timeStart).local().format("YYYY-MM-DD HH:mm")}</TableCell>
                                    <TableCell>{game.status}</TableCell>
                                    <TableCell>
                                        <CheckboxCms isReadyOnly={true} value={game.doubleStart}/>
                                    </TableCell>
                                    <TableCell>{game.legsToWin}</TableCell>
                                    <TableCell>{generateButtons(game)}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
            <Container textAlign='right'>
                <AppPagination props={pagination} onChangePager={onChangePager} onChangePageSize={onChangePageSize} />
            </Container>
            {isShowFilter &&
                <DartsGamesFilter closeFilter={setIsShowFilter} />
            }
            {isVisibleForm &&
                <DartsGamesCRUDForm />
            }
        </div>
    );
};

export default DartsGamesCRUD;